module.exports = __webpack_public_path__ + "img/dual-water-sm.21a5462e.svg";